export class DelayedCall {

	public fn:any;
	public delay:number = 10;
	private destroyed:boolean = false;
	private timeout_id:any;

	constructor(fn:any, delay:number, autostart:boolean=true) {
		this.fn = fn;
		this.delay = delay;
		if(autostart) {
			this.restart();
		}
	}
	cancel() {
		if(this.destroyed) return;
		if(this.timeout_id!=null) {
			try { clearTimeout(this.timeout_id); } catch(e) {};
			this.timeout_id = null;
		}
	}
	restart() {
		if(this.destroyed) return;
		this.cancel();
		this.timeout_id = setTimeout(this.fn, this.delay);
	}
	destroy() {
		if(this.destroyed) return;
		this.cancel();
		this.destroyed = true;
		this.fn = null;
		this.destroyed = true;
	}
}
